import 'core-js/modules/es.object.to-string';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.regexp.to-string';
import 'core-js/modules/es.string.replace';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import { ARROW_DOWN, ARROW_UP, SPACE, ENTER } from './key-codes.js';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }
var DEFAULT_NO_OPTIONS_MESSAGES = {
  noOptions: 'No options',
  nothingFound: 'Nothing found',
  loading: 'Loading...'
};
function shouldOpenSelect(key) {
  return key === ARROW_DOWN || key === ARROW_UP || key === SPACE || key === ENTER;
}

function isString(s) {
  return Object.prototype.toString.call(s) === '[object String]';
}

function getEmptyMessage(isLoading, isNothingFound, noOptionsMessage) {
  var _ref = isString(noOptionsMessage) ? _objectSpread(_objectSpread({}, DEFAULT_NO_OPTIONS_MESSAGES), {}, {
    noOptions: noOptionsMessage
  }) : _objectSpread(_objectSpread({}, DEFAULT_NO_OPTIONS_MESSAGES), noOptionsMessage),
      noOptions = _ref.noOptions,
      nothingFound = _ref.nothingFound,
      loading = _ref.loading;

  if (isLoading) {
    return loading;
  } else if (isNothingFound) {
    return nothingFound;
  } else {
    return noOptions;
  }
}
function escapeRegex(str) {
  return str.replace(/[\-\[\]\/{}()\*+?.\\^$|]/g, '\\$&');
}
function convertToOptionGroupsIfNeeded() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (containsGroups(options)) {
    return options;
  } else {
    return [{
      options: options
    }];
  }
}

function containsGroups(opts) {
  return opts.length > 0 && opts[0].options && _Array$isArray(opts[0].options);
}

export { convertToOptionGroupsIfNeeded, escapeRegex, getEmptyMessage, shouldOpenSelect };
